import CustomerOrderListPagingResultModelBase from '../_generated/modelBases/customer-order-list-paging-result-model-base';

export default class CustomerOrderListPagingResultModel extends CustomerOrderListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
